import {
  Modal,
  UseModalProps,
  ButtonRow,
  FormButton,
  FlexLoadingBlock,
} from "@synota-io/synota-shared-ui";
import { useNodeUsers } from "../../../api/hooks/useNodeUsers";
import { useParams } from "react-router-dom";
import { NodeUserDetails } from "../components/NodeUserDetails";
import { Alert, AlertTitle } from "@mui/material";

type Props = UseModalProps;

export const NodeUserDetailsModal = ({ open, onClose }: Props) => {
  const { nodeUuid, userUuid } = useParams<{ nodeUuid: string; userUuid: string }>();
  const { nodeUsers, isFetching, error } = useNodeUsers(
    { server_uuid: nodeUuid },
    { enabled: open },
  );

  const selectedUser = nodeUsers.find((u) => u.uuid === userUuid);

  const actions = (
    <ButtonRow>
      <FormButton variant="text" color="error" size="small" onClick={onClose}>
        Close
      </FormButton>
    </ButtonRow>
  );

  const modalContent = isFetching ? (
    <FlexLoadingBlock>Loading user details...</FlexLoadingBlock>
  ) : error || !selectedUser ? (
    <Alert severity="error">
      <AlertTitle>Failed to load user details</AlertTitle>
      <pre>{JSON.stringify(nodeUsers)}</pre>
    </Alert>
  ) : (
    <NodeUserDetails user={selectedUser} />
  );

  return (
    <Modal
      fullWidth
      maxWidth="sm"
      open={open}
      onClose={onClose}
      title={selectedUser?.public_name || selectedUser?.email || "User"}
      actions={actions}
    >
      {modalContent}
    </Modal>
  );
};
